import { render, staticRenderFns } from "./PortefeuilleBeneficiaries.vue?vue&type=template&id=fd44a00c&scoped=true"
import script from "./PortefeuilleBeneficiaries.vue?vue&type=script&lang=js"
export * from "./PortefeuilleBeneficiaries.vue?vue&type=script&lang=js"
import style0 from "./PortefeuilleBeneficiaries.vue?vue&type=style&index=0&id=fd44a00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd44a00c",
  null
  
)

export default component.exports